import { Reveal, GoldLine } from "@/components/Reveal";

export const SectionHeading = ({ eyebrow, title, copy, align = "center" }) => {
    const alignCls = align === "center" ? "text-center items-center" : "text-left items-start";
    return (
        <div className={`flex flex-col ${alignCls} gap-4 mb-12 sm:mb-16`} data-testid="section-heading">
            {eyebrow && (
                <Reveal>
                    <span className="eyebrow" data-testid="section-eyebrow">{eyebrow}</span>
                </Reveal>
            )}
            <Reveal delay={0.08}>
                <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.12] tracking-tight max-w-3xl">
                    {title}
                </h2>
            </Reveal>
            <GoldLine delay={0.15} className="w-16" />
            {copy && (
                <Reveal delay={0.2}>
                    <p className="text-sand text-sm sm:text-base max-w-xl leading-relaxed">{copy}</p>
                </Reveal>
            )}
        </div>
    );
};

export default SectionHeading;
